'use strict';

var _ = require('lodash');
var SnapshotDatesChartDirective = function SnapshotDatesChartDirective(Chart, Viewport) {
  return {
    restrict: 'E',
    template: require('../templates/snapshot-dates-chart.html'),
    scope: {
      isCollapsible: '=',
      isChartVisible: '=?',
      onResetBrushes: '=?'
    },
    replace: true,
    controller: 'SnapshotDatesChartController',
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var viewportElement = element.find('.viewport-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      var viewport = new Viewport(viewportElement, scope.viewportFormatters);
      scope.renderChartDataPresent = function (data, selectionSize, silentViewportSelection) {
        scope.$evalAsync(function () {
          scope.data = data || [];
          var currentRange = scope.currentRange;
          setTimeout(function () {
            chart.changeMetrics().render(data);
            viewport.changeMetrics().render(data, selectionSize, 30);
            if (scope.data && scope.data.length && !silentViewportSelection) {
              var range = isCurrentRangeInVisibleRange(currentRange) ? currentRange : [scope.data.length - 30, scope.data.length];
              if (range[0] < 0) {
                range[0] = 0;
              }
              viewport.setInitialSelection(range);
            }
          }, 0);
        });
      };
      scope.toggleChartVisibility = function () {
        scope.isChartVisible = !scope.isChartVisible;
        if (scope.isChartVisible) {
          setTimeout(scope.renderChartDataPresent, 0);
        }
      };
      scope.$watch('isChartVisible', function (newValue, oldValue) {
        if (oldValue !== newValue && newValue === true) {
          setTimeout(scope.renderChartDataPresent, 0);
        }
      });
      function isCurrentRangeInVisibleRange(currentRange) {
        return !_.isUndefined(currentRange) && currentRange[0] < viewport.visibleXRange[1] && currentRange[1] <= viewport.visibleXRange[1];
      }
      scope.setInitialSelection = function (range) {
        chart.setInitialSelection(range);
      };
      scope.$on('search-criteria:searchChangeEvent', function () {
        scope.initChart();
      });
      scope.$on('SnapshotDatesChart:changeLegend:metrics', function (evt, selectedLegend) {
        scope.changeMetric(selectedLegend);
        scope.$evalAsync(function () {
          if (!scope.data) {
            return;
          }
          var currentRange = viewport.getSelection();
          scope.reloadChart(currentRange);
        });
      });

      // brush change in the viewport chart affects what's visible in the main chart
      viewport.on('rangechange', function (range) {
        scope.currentRange = range;
        chart.domainChange(range);
      });
      chart.on('selectSnapshotDate', function (snapshotDateData) {
        scope.broadcastSelectedSnapshotData(snapshotDateData, true);
      });
    }
  };
};
SnapshotDatesChartDirective.$inject = ['SnapshotDatesChart', 'SnapshotDatesViewport'];
module.exports = SnapshotDatesChartDirective;